import { MarketingChannel } from "@redotech/redo-model/marketing";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const setCustomerSuppressed = {
  name: "setCustomerSuppressed" as const,
  input: z.object({
    customerId: zExt.objectId(),
    action: z.enum(["suppress", "unsuppress"]),
    channel: z.enum(MarketingChannel),
  }),
  output: z.object({}),
};
